import { render, staticRenderFns } from "./VehicleSelectorButton.vue?vue&type=template&id=5ba97e6b"
import script from "./VehicleSelectorButton.vue?vue&type=script&lang=js"
export * from "./VehicleSelectorButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports